/* FIXME: This component was modified to look as sunrise but needs to be migrated to use the new Sunrise components */
import type React from 'react';

import { Image } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';
import { RadioGroup } from '@change-corgi/design-system-legacy/components/forms';

import type { StarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { RadioCard } from '#src/app/pages/starterDashboardV2/shared/components';
import { useShareVisualModalBody } from '#src/app/pages/starterDashboardV2/shared/hooks';

import { shareVisualItemStyles } from './index.styles';

type Petition = StarterDashboardV2PageData['petition'];
type Context = 'starter_dashboard_grow_petition';
type Props = { petition: Petition; context: Context; onChange: () => void; className?: string };

export const ShareVisualContent: React.FC<Props> = ({ petition, context, onChange, className }) => {
	const { data } = useShareVisualModalBody({ petition, context });
	const { translate } = useI18n();

	return (
		<RadioGroup
			aria-label={translate('corgi.petition.starter_dashboard.shared.share_visuals.modal_form_aria_label')}
			name="share-visuals"
			onChange={onChange}
			className={className}
		>
			<div
				className="box-border flex snap-x snap-mandatory gap-4 overflow-x-auto md:justify-between md:overflow-visible"
				sx={{
					scrollbarWidth: 'none',
					msOverflowStyle: 'none',
				}}
				data-testid="share-visual-content-container"
				data-qa="share-visual-content-container"
				tabIndex={-1}
			>
				{data.shareVisuals.map((shareVisual) => (
					<div key={shareVisual.id} className={shareVisualItemStyles({ hasMany: data.shareVisuals.length > 2 })}>
						<RadioCard
							className="box-border rounded-lg"
							label={
								<div className="bg-background-overlay px-3 pt-2 pb-2 leading-0">
									<Image
										src={shareVisual.image.src}
										srcSet={shareVisual.image.srcSet}
										alt={shareVisual.image.alt}
										className="rounded-lg"
										aspectRatio="1:1"
									/>
								</div>
							}
							value={shareVisual.variantName}
						/>
					</div>
				))}
			</div>
		</RadioGroup>
	);
};
